import { type AriaRole, type HTMLProps, forwardRef } from "react";

import { Box, type BoxProps } from "metabase/ui";

import { BaseSelectListItem } from "./BaseSelectListItem";
import { SelectListItem } from "./SelectListItem";

type SelectListProps = Omit<HTMLProps<HTMLUListElement>, "role"> &
  BoxProps & {
    role?: AriaRole;
  };

const SelectListInner = forwardRef<HTMLUListElement, SelectListProps>(
  function SelectList({ role = "menu", ...props }: SelectListProps, ref) {
    return (
      <Box
        {...props}
        ref={ref}
        role={role}
        data-testid="select-list"
        component="ul"
      />
    );
  },
);

export const SelectList = Object.assign(SelectListInner, {
  BaseItem: BaseSelectListItem,
  Item: SelectListItem,
});
